module.exports = __webpack_public_path__ + "img/favictor-icon.94a9e743.png";